module.exports = __webpack_public_path__ + "static/media/Excell_Disabled.5908adf9.svg";